export default class StoreDefineLogin {
  private static readonly NAMESPACE = 'user_login_';
  public static readonly GET_LOGIN_STATE = StoreDefineLogin.NAMESPACE + 'get_login_state';
  public static readonly SET_LOGIN_STATE = StoreDefineLogin.NAMESPACE + 'set_login_state';
}
